import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpEvent, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class UploadFileService {
    constructor(private http: HttpClient) {
    }

    uploadRequest(file: File, urlPath): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();

        formData.append('file', file);

        const req = new HttpRequest('POST', `agri` + urlPath, formData, {
            reportProgress: true,
            responseType: 'json'
        });

        return this.http.request(req);
    }

    upload(theFile, urlPath) {

        if (theFile) {
            let file: File | null = theFile.item(0);

            if (file) {
                this.uploadRequest(file, urlPath).subscribe(uploadResponse => {
                });
            }
            file = undefined;
        }
    }
}
